// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"208":"mandoob_users","346":"stores","486":"orders","818":"auth"}[chunkId] || chunkId) + "-legacy." + {"15":"bcc5f1b4","208":"ad255eb7","346":"969466a2","367":"d2f48ac8","484":"7ee3b8c5","486":"013cfe5c","818":"6bf66463"}[chunkId] + ".js";
};